import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

import "./Review.css";

// import required modules
import { Autoplay, FreeMode, Pagination, Mousewheel, Keyboard } from "swiper";

import customer0 from '../../../../assets/fakepic.png';
// import customer1 from '../../../../assets/images/Customers/customer1.png';

const Review = () => {
    const clientsReview = [
        {
            id: 1,
            image: customer0,
            name: `Karine Schrenzel`,
            comments:
                `Je n'ai jamais été un grand fan de la cuisine indienne, principalement parce que je pouvais trouver des options plus saines pour manger, mais je dois dire que j'adore cet endroit.Mon plat habituel pour le plat sain est l'apéritif hors d'œuvres pour deux de poulet et d'agneau grillés. Parfois, je l'obtiens avec un peu de naan et en utilisant les trempettes. La soupe mulligatawny est également très bonne, même si elle peut parfois être un peu trop salée.Le gars qui travaille toujours là-bas, Dominic, est aussi un gars si gentil. Il se souvient toujours de nous quand nous sommes entrés et quand ce que nous avons commandé la dernière fois que nous y étions. Un gars si gentil!Super endroit pour grignoter et profiter, même si j'aurais aimé que la musique soit un peu moins prévisible et habituelle et un peu plus unique, branchée et / ou amusante / moderne.`,
        },
        {
            id: 2,
            image: customer0,
            name: `Fabien Pelous`,
            comments:
                `c'était la première fois que je mangeais de la nourriture indienne. J'ai commandé du poulet tikka masala et du biryani aux légumes. Le poulet tikka était un 4. 5/10 simplement parce qu'il était plus liquide et qu'il n'était ni chaud ni épicé du tout. c'était une saveur très douce, et j'ai demandé qu'elle soit épicée. donc je suppose que c'est leur plus épicé. le birriyani végétal est sorti avec une couleur orange rougeâtre. très étrange mais je n'étais pas fan des ingrédients uniques car je suis plus habitué à ceux qui contiennent plus de brocoli et de pommes de terre. ce n'est pas de la mauvaise nourriture dans l'ensemble, j'ai juste un niveau plus élevé.`,
        },
        {
            id: 3,
            image: customer0,
            name: `Benjamin Durand-Servoingt`,
            comments:
                `Certaines des meilleures discussions que j'ai eues depuis un moment. Les gens de mon groupe ont commandé aloo tikki chaat, bhel puri, dahi papadi chaat, dahi batata et pack bhaji et nous avons tous été très impressionnés. Le service est vraiment rapide aussi!`,
        },
        {
            id: 4,
            image: customer0,
            name: `Fabien Pelous`,
            comments:
                `Excellente nourriture. Je suis venu pour un déjeuner d'anniversaire et j'ai essayé un peu de tout. Tout était super !!`,
        },
        {
            id: 5,
            image: customer0,
            name: `Benjamin Durand-Servoingt`,
            comments:
                `D'accord, ce n'était donc pas ce que j'avais l'intention de faire, mais la nourriture et le service étaient excellents! L'intérieur du restaurant est charmant et la nourriture est venue rapidement. Je mangerais ici à nouveau à coup sûr!`,
        },
        {
            id: 6,
            image: customer0,
            name: `Hanene Maupas`,
            comments:
                `Je cherchais un restaurant indien avec de la bonne nourriture et des options végétaliennes. Nous avons été ravis des plats servis. Le service était excellent, nous recommandons le Saag Aloo. Dans l'ensemble, bonne nourriture et glaces délicieuses! ! !`,
        },
    ];
    return (
        <div className="reviewSlider">
            <div className="row gx-0 d-flex justify-content-center align-items-center review-area">
                <div className="col-11 col-md-8">
                    <div className="row gx-0 mt-5 mt-md-5">
                        <div className="col-12 col-md-12">
                            <h1 className="section-header">Client Heureux</h1>
                        </div>
                    </div>
                    <div className="row gx-0">
                        <div className="col-12 col-md-12">
                            <Swiper
                                // slidesPerView={2}
                                spaceBetween={50}
                                freeMode={true}
                                pagination={{
                                    clickable: true,
                                }}
                                mousewheel={false}
                                keyboard={true}
                                modules={[Autoplay, FreeMode, Pagination, Mousewheel, Keyboard]}
                                className="reviewSwiper"
                                loop={true}
                                autoplay={{
                                    delay: 2000,
                                    disableOnInteraction: false,
                                }}
                                breakpoints={
                                    {
                                        // when window width is >= 320px
                                        320: {
                                            slidesPerView: 1,
                                        },
                                        // when window width is >= 767px
                                        767: {
                                            slidesPerView: 2,
                                        }
                                    }
                                }
                            >
                                {
                                    clientsReview.slice(0, 3).map((review, index) =>
                                        <SwiperSlide key={review.id}>
                                            <div className="row gx-0 py-5 pb-md-5" style={{ backgroundColor: '#rgb(2 29 42)' }}>
                                                <div className="col-12 col-md-12">
                                                    <div className="row gx-0 d-flex flex-column justify-content-center align-items-center pb-3 pb-md-3 ps-2 ps-md-2">
                                                        <div className="col-2 col-md-2 d-flex justify-content-center align-items-center">
                                                            <img src={review.image} alt="client" height="60" />
                                                        </div>
                                                        <div className="col-10 col-md-10 d-flex justify-content-center align-items-center ps-0 pt-3 ps-md-0 pt-md-3">
                                                            <h6 className="fw-bold text-center">{review.name}</h6>
                                                        </div>
                                                    </div>
                                                    <div className="row gx-0 review p-3 mb-3 mx-2 rounded">
                                                        <div className="col-12 col-md-12">
                                                            <p className="text-start fs-6">{review.comments.slice(0, 150)} {`....`}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    )
                                }
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Review;